import { flattenCategories } from './flatten-categories';
export function findLevelOneCategoryForCategoryId(_a) {
    var categoryId = _a.categoryId, categories = _a.categories;
    if (!categories || !categories.length || !categoryId) {
        return null;
    }
    var flattenedCategories = flattenCategories(categories);
    var foundCategory = flattenedCategories[categoryId];
    if (!foundCategory) {
        return null;
    }
    var currentCategory = foundCategory;
    while (currentCategory.level !== 1) {
        var parentCategory = flattenedCategories[currentCategory.parentId];
        if (!parentCategory) {
            break;
        }
        currentCategory = parentCategory;
    }
    return currentCategory;
}
